import type { PaymentMethodItem } from '../PaymentMethods.types'
import { getDefaultPaymentMethod } from './getDefaultPaymentMethod'

export const getErrorBanner = (paymentMethods?: PaymentMethodItem[]) => {
  const defaultPaymentMethod = getDefaultPaymentMethod(paymentMethods)

  if (!defaultPaymentMethod) {
    return 'There is no default payment method selected. Please choose a new default payment method.'
  }

  if ('expired' in defaultPaymentMethod && defaultPaymentMethod.expired) {
    return 'Your default payment method is expired. Please choose a new default payment method. '
  }

  if (defaultPaymentMethod.invalid) {
    return 'Your default payment method is invalid. Please choose a new default payment method.'
  }

  return undefined
}
